import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

/**
 * SubServiceFillerCell — a single 2-col grid cell that says "Custom scope?
 * Talk to us." Used to pad the per-service sub-services lists on the survey-techies
 * and cad-techies detail sections when the sub-service count is odd (leaving an
 * orphan empty cell at the bottom of a 2-col grid).
 *
 * Lightweight by design — visually distinct from real sub-service cards so
 * users can tell at a glance it's a CTA, not a content cell.
 */
export default function SubServiceFillerCell({ serviceName, testid = "sub-filler" }) {
  return (
    <li
      data-testid={testid}
      className="bg-paper-dark/30 p-4 lg:p-5 flex flex-col gap-2 relative"
    >
      <div className="flex items-center gap-1.5 mono text-[10px] tracking-[0.22em] uppercase text-orange-survey">
        <Sparkles className="h-3 w-3" /> Custom scope
      </div>
      <div className="display text-sm font-extrabold tracking-tight text-slate-900">
        Not listed? We can scope it.
      </div>
      <p className="text-sm text-slate-600 leading-relaxed">
        Tell us what {serviceName ? `${serviceName.toLowerCase()} ` : ""}deliverable you
        need — we&apos;ll draft a fixed-price proposal in 24 hours.
      </p>
      <Link
        to="/contact"
        className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-topo hover:text-orange-survey transition-colors"
      >
        Ask Tri-Axis <ArrowUpRight className="h-4 w-4" />
      </Link>
    </li>
  );
}
